// extracted by mini-css-extract-plugin
module.exports = {"loader":"Listbox_loader__gAnEa","sensor":"Listbox_sensor__1woEc"};